import Vue from 'vue';
import isNil from 'lodash/isNil';

import { getLocale } from '@/helpers/locale-helper';
import { formatDate } from '@/helpers/utility';

Vue.filter('formatDate', function(value, format) {
  if (value) {
    return formatDate(value, format);
  }
});

Vue.filter('upper', function(value) {
  if (!value) {
    return '';
  }
  return value.toString().toUpperCase();
});

Vue.filter('crop', function(value, len) {
  let val = value ? value.toString() : '';
  return val.length > len ? val.substr(0, len) + ' ...' : val;
});

Vue.filter('fileSize', function(value, unit, len) {
  let _value = Number(value);
  if (!isNaN(_value) && _value !== 0) {
    let _unit = unit || 'Kb';
    if (_unit === 'auto') {
      _unit = value > (1024 * 1024 * 1024)
        ? 'Gb'
        : value > (1024 * 1024)
          ? 'Mb'
          : value > 1024 ? 'Kb' : 'B';
    }
    let unitVal;
    switch (_unit) {
      case 'Gb':
        unitVal = value / 1024 / 1024 / 1024;
        break;
      case 'Mb':
        unitVal = value / 1024 / 1024;
        break;
      case 'Kb':
        unitVal = value / 1024;
        break;
      default:
        unitVal = value;
        _unit = 'B';
        break;
    }
    return `${parseFloat(unitVal.toFixed(isNil(len) ? 2 : len))} ${_unit}`;
  } else {
    return '';
  }
});

Vue.filter('currency', function(value) {
  return isNil(value) ? '' : `${value} ${getLocale('dictionary.currencies.uah')}`;
});

Vue.filter('delivery', function(value) {
  return isNil(value) ? '' : `${value} ${getLocale('dictionary.currencies.delivery')}`;
});
